module.exports = __webpack_public_path__ + "static/media/NoData-Objectives.1486d5d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/performances/NoData-Objectives.svg
// module id = 1767
// module chunks = 0